<template>
  <b-card class="h-100">
    <b-card-title v-if="$hidderComponent('task:list[assigned]', (isService = false))" class="mb-4">Tâches</b-card-title>
    <h-m-styled-plaintext v-model="actualNav" class="mb-3" :nav-choices="navChoices"></h-m-styled-plaintext>
    <div v-if="loaded && tasks.length > 0" class="overflow-auto" style="height: calc(100% - 100px)">
      <b-row v-for="(task, index) in tasks" :key="index" class="w-100 align-items-center mb-2">
        <b-col cols="10" class="cursor-pointer" @click="goToTask(task)">
          {{ task.dashboard_title }} - {{ task.title }} -
          {{ task.date | formatDate }}
        </b-col>
        <b-col cols="2" class="d-flex">
          <h-b-action-rounded icon="bx bx-check-double" @click.native="finishTask(index)"></h-b-action-rounded>
          <h-b-action-rounded
            icon="bx bx-trash-alt"
            class="ml-2"
            @click.native="deleteTask(index)"
          ></h-b-action-rounded>
        </b-col>
      </b-row>
    </div>
    <h-e-spinner v-if="!loaded"></h-e-spinner>
    <h4 v-if="tasks.length === 0 && loaded" class="text-primary text-center">Vous n'avez pas de tâche</h4>
  </b-card>
</template>

<script>
import moment from 'moment'
import { FunctionHelpers, Hk } from '@/node-sdk'
import { hidderComponent } from '@/state/helpers'

const { Task } = Hk.Event

export default {
  name: 'task',

  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
  },

  data() {
    return {
      tasks: [],
      loaded: false,
      navChoices: [
        { text: "Aujourd'hui", link: 'today', active: false },
        { text: 'Cette semaine', link: 'week', active: false },
      ],
      actualNav: 'today',
    }
  },

  watch: {
    actualNav() {
      if (this.loaded) {
        this.getTasks()
      }
    },
  },

  mounted() {
    this.getTasks()
  },

  methods: {
    getTasks() {
      if (this.$hidderComponent('task:list[assigned]', false)) {
        this.loaded = false
        const today = new Date()
        const firstDay = today.getDate() - today.getDay()
        const lastDay = new Date(today.setDate(firstDay + 6))
        Task.get({
          params: {
            assigned_user: this.getUserMe(),
            date_after: moment(this.actualNav === 'today' ? new Date() : firstDay).format('YYYY-MM-DD'),
            date_before: moment(this.actualNav === 'today' ? new Date() : lastDay).format('YYYY-MM-DD'),
            finished: false,
          },
        }).then((response) => {
          ;[this.tasks] = response
          this.loaded = true
        })
      }
    },

    getUserMe() {
      return JSON.parse(localStorage.getItem('user_object')).uuid
    },

    async deleteTask(index) {
      const response = await FunctionHelpers.confirmModal('Supprimer')
      if (response.value) {
        await Task.delete(this.tasks[index].id)
        this.$delete(this.tasks, index)
      }
    },

    async finishTask(index) {
      const result = await FunctionHelpers.confirmModalSuccess('Terminer la tâche')
      if (result.value) {
        this.tasks[index].finished = true
        await Task.patch(this.tasks[index].id, { data: this.tasks[index] })
        this.$delete(this.tasks, index)
      }
    },

    goToTask(task) {
      window.open(task.link, '_blank')
    },
  },
}
</script>

<style scoped></style>
